import { VStack, Text, Button, Icon, useToast, useDisclosure } from '@chakra-ui/react';

import LeaveOrCancelGroupModal from '~/components/LeaveOrCancelGroupModal';

import { useParams } from 'react-router-dom';

import groupHostInfoAtom from '~/recoil/atom/groupHostInfo';
import { useRecoilValue } from 'recoil';

import QRcode from 'react-qr-code';

import { IoPaperPlaneOutline } from 'react-icons/io5';

export default function HostContent() {
  const { groupId = '' } = useParams();
  const groupHostInfo = useRecoilValue(groupHostInfoAtom);

  const toast = useToast({ duration: 1000, position: 'top' });

  const { isOpen, onClose, onOpen } = useDisclosure();

  const shareLink = `${window.location.origin}/group/${groupId}`;

  const handleShareLink = async () => {
    if (!!window.navigator.share) {
      const shareData = {
        title: '蔬氧VO2 團購',
        text: `${groupHostInfo.name} 發起的團購：${groupHostInfo.note}`,
        url: shareLink,
      };

      await window.navigator.share(shareData);
      return;
    }

    try {
      await window.navigator.clipboard.writeText(shareLink);
      toast({
        status: 'success',
        title: '複製連結成功',
      });
    } catch (err) {
      toast({
        status: 'error',
        title: '複製連結失敗',
      });
    }
  };

  return (
    <VStack spacing={6}>
      <QRcode value={shareLink} size={128} />
      <Text fontSize="sm" color="secondary" textAlign="center">
        可透過掃QRcode或複製連結給朋友
        <br />
        讓他們一起加入點餐
      </Text>
      <Button leftIcon={<Icon as={IoPaperPlaneOutline} />} onClick={handleShareLink}>
        分享連結
      </Button>
      <Button variant="unstyled" fontWeight="normal" color="secondary" onClick={onOpen}>
        取消揪團
      </Button>

      <LeaveOrCancelGroupModal isOpen={isOpen} onClose={onClose} isHost={true} />
    </VStack>
  );
}
